import { render } from "./Announcement.vue?vue&type=template&id=3007e51e&ts=true"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__